var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMemo, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../api';
var POLICY_DOCUMENT_FETCH_MS = 15 * 60 * 1000;
var allowedProduct = [
    'coterie-gl',
    'coterie-eo',
    'coterie-bop',
    'employers-wc',
];
var isEmployersOrCoterieProduct = function (productName) {
    if (!productName)
        return false;
    var normalized = productName.toLowerCase();
    return allowedProduct.includes(normalized);
};
var parseNextPolicyDocumentFetchAtMs = function (nextPolicyDocumentFetchAtRaw) {
    if (nextPolicyDocumentFetchAtRaw == null) {
        return undefined;
    }
    if (typeof nextPolicyDocumentFetchAtRaw === 'number') {
        return nextPolicyDocumentFetchAtRaw;
    }
    if (typeof nextPolicyDocumentFetchAtRaw === 'string') {
        var asNumber = Number(nextPolicyDocumentFetchAtRaw);
        if (!Number.isNaN(asNumber)) {
            return asNumber;
        }
        var parsed = Date.parse(nextPolicyDocumentFetchAtRaw);
        if (!Number.isNaN(parsed)) {
            return parsed;
        }
    }
    return undefined;
};
var usePolicyDocumentFetch = function (latestPolicy, latestQuote) {
    var _a, _b, _c, _d, _e, _f;
    var _g = useState(null), policyDocsError = _g[0], setPolicyDocsError = _g[1];
    var queryClient = useQueryClient();
    var hasPolicyDocuments = ((_c = (_b = (_a = latestPolicy === null || latestPolicy === void 0 ? void 0 : latestPolicy.partnerData) === null || _a === void 0 ? void 0 : _a.documents) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0;
    var createdPolicy = (_d = latestPolicy === null || latestPolicy === void 0 ? void 0 : latestPolicy.partnerData) === null || _d === void 0 ? void 0 : _d.createdAt;
    var showDocumentFetchForProduct = isEmployersOrCoterieProduct(latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.externalId);
    var nextPolicyDocumentFetchAtRaw = ((_e = latestPolicy === null || latestPolicy === void 0 ? void 0 : latestPolicy.partnerData) === null || _e === void 0 ? void 0 : _e.hasOwnProperty('nextPolicyDocumentFetchAt'))
        ? (_f = latestPolicy === null || latestPolicy === void 0 ? void 0 : latestPolicy.partnerData) === null || _f === void 0 ? void 0 : _f.nextPolicyDocumentFetchAt
        : new Date(createdPolicy).getTime() + POLICY_DOCUMENT_FETCH_MS;
    var nextPolicyDocumentFetchAtMs = useMemo(function () { return parseNextPolicyDocumentFetchAtMs(nextPolicyDocumentFetchAtRaw); }, [nextPolicyDocumentFetchAtRaw]);
    var eligibleForAutoFetch = (latestPolicy === null || latestPolicy === void 0 ? void 0 : latestPolicy.partnerIdentifier) === 'brizaunifiedhiscox' &&
        showDocumentFetchForProduct &&
        !hasPolicyDocuments;
    var initialCanShowFetchButton = eligibleForAutoFetch &&
        (nextPolicyDocumentFetchAtMs === undefined ||
            Date.now() >= nextPolicyDocumentFetchAtMs);
    var fetchPolicyDocumentsMutation = useMutation(function () {
        return api.policy.fetchPolicyDocuments({
            policyId: latestPolicy.id
        });
    }, {
        onSuccess: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setPolicyDocsError(null);
                        return [4 /*yield*/, queryClient.invalidateQueries(['customer'])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var message;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        message = ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) ||
                            'Failed to fetch documents';
                        setPolicyDocsError("".concat(message, ". Please try again later."));
                        setTimeout(function () {
                            setPolicyDocsError(null);
                        }, 15000);
                        return [4 /*yield*/, queryClient.invalidateQueries(['customer'])];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); }
    });
    return {
        hasPolicyDocuments: hasPolicyDocuments,
        showDocumentFetchForProduct: showDocumentFetchForProduct,
        initialCanShowFetchButton: initialCanShowFetchButton,
        fetchPolicyDocumentsMutation: fetchPolicyDocumentsMutation,
        nextPolicyDocumentFetchAtMs: nextPolicyDocumentFetchAtMs,
        policyDocsError: policyDocsError
    };
};
export default usePolicyDocumentFetch;
